function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.42093 13.4098C9.52591 13.5148 9.6674 13.5696 9.8089 13.5696C9.95039 13.5696 10.0873 13.5148 10.1969 13.4098L14.2363 9.37042C14.4508 9.1559 14.4508 8.80901 14.2363 8.59449C14.0217 8.37996 13.6749 8.37996 13.4603 8.59449L9.80433 12.2505L8.53546 10.9816C8.32093 10.7671 7.97405 10.7671 7.75952 10.9816C7.545 11.1961 7.545 11.543 7.75952 11.7576L9.42093 13.4098Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.19469 2.85765C5.29967 2.85765 5.40465 2.8257 5.5005 2.76636C5.75154 2.59748 5.82 2.25516 5.65112 2.00412C5.48224 1.75308 5.14448 1.68462 4.88888 1.8535C4.63785 2.02238 4.56938 2.36014 4.73826 2.61117C4.84324 2.77093 5.01668 2.85765 5.19469 2.85765Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.61038 4.15811C3.75187 4.15811 3.89337 4.10333 3.99835 3.99835C4.21287 3.78383 4.21287 3.43694 3.99835 3.22242C3.78382 3.00789 3.43694 3.00789 3.22241 3.22242C3.00789 3.43694 3.00789 3.78383 3.22241 3.99835C3.32739 4.10333 3.46889 4.15811 3.61038 4.15811Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.99682 1.88926C7.06529 1.88926 7.13832 1.87557 7.20678 1.84819C7.48521 1.73408 7.61757 1.41001 7.50346 1.13159C7.38936 0.853166 7.06529 0.720801 6.78686 0.834909C6.50844 0.949017 6.37607 1.27308 6.49018 1.55151C6.5769 1.76146 6.7823 1.88926 6.99682 1.88926Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M2.00412 5.64559C2.09541 5.70949 2.20495 5.73688 2.30993 5.73688C2.48794 5.73688 2.66138 5.65016 2.76636 5.49497C2.93524 5.24393 2.86678 4.9016 2.61574 4.73729C2.3647 4.56841 2.02238 4.63687 1.8535 4.88791C1.68462 5.13895 1.75308 5.47671 2.00412 5.64559Z",
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M1.13257 7.50341C1.20103 7.53079 1.27406 7.54449 1.34252 7.54449C1.55705 7.54449 1.76244 7.41669 1.84916 7.20673C1.96327 6.92831 1.83091 6.60881 1.55248 6.49014C1.27406 6.37147 0.954558 6.5084 0.835886 6.78682C0.721778 7.0698 0.854143 7.3893 1.13257 7.50341Z",
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M8.95463 1.29662C8.99115 1.29662 9.0231 1.29205 9.05961 1.28749C9.35629 1.22815 9.54799 0.940601 9.48866 0.64392C9.42932 0.34724 9.14177 0.155539 8.84509 0.214875C8.54841 0.274211 8.35671 0.561763 8.41605 0.858443C8.47082 1.11404 8.69903 1.29662 8.95463 1.29662Z",
  fill: "currentColor"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M0.639037 9.49811C0.675552 9.50268 0.712066 9.50724 0.744017 9.50724C0.999618 9.50724 1.22783 9.32467 1.28261 9.0645C1.34194 8.76782 1.15024 8.48027 0.85356 8.42093C0.55688 8.36159 0.269328 8.5533 0.209992 8.84998C0.150656 9.15122 0.342357 9.43878 0.639037 9.49811Z",
  fill: "currentColor"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7776 3.22241C16.7008 1.14564 13.9394 0 11 0C10.6988 0 10.4523 0.246473 10.4523 0.547718C10.4523 0.848963 10.6988 1.09544 11 1.09544C16.4635 1.09544 20.9046 5.53651 20.9046 11C20.9046 16.4635 16.4635 20.9046 11 20.9046C5.53651 20.9046 1.09544 16.4635 1.09544 11C1.09544 10.6988 0.848963 10.4523 0.547718 10.4523C0.246473 10.4523 0 10.6988 0 11C0 13.9394 1.14564 16.7008 3.22241 18.7776C5.29917 20.8544 8.06058 22 11 22C13.9394 22 16.7008 20.8544 18.7776 18.7776C20.8544 16.7008 22 13.9394 22 11C22 8.06058 20.8544 5.29917 18.7776 3.22241Z",
  fill: "currentColor"
});

var SvgStep3 = function SvgStep3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStep3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/step3.61a11bb7.svg";
export { ForwardRef as ReactComponent };